import { IoMdPlay } from "react-icons/io";
import { FaPause } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { FiSearch } from "react-icons/fi";
import { RxCross1 } from "react-icons/rx";
import { FaRegHeart } from "react-icons/fa";
import { FaRegUser } from "react-icons/fa";
import { IoCartOutline } from "react-icons/io5";
import { IoMdMenu } from "react-icons/io";

import {
  MdLanguage,
  MdAddShoppingCart,
  MdHistory,
  MdHelp,
  MdListAlt,
  MdApps,
  MdBuild,
  MdFeedback,
} from "react-icons/md";
import { GoHome } from "react-icons/go";

import { FiMapPin } from "react-icons/fi";

import sparkicon from "./assets/images/spark-icon.svg";
import mobileicon from "./assets/images/mobileicon.webp";

import fallbackimg from "./assets/images/fallback.webp";
import fallbackimg1 from "./assets/images/fallback1.webp";

import grid1 from "./assets/images/grid1.avif";
import grid2 from "./assets/images/grid2.webp";
import grid3 from "./assets/images/grid3.webp";
import grid4 from "./assets/images/grid4.webp";
import grid5 from "./assets/images/grid5.jpg";

import left1 from "./assets/images/left1.avif";
import right1 from "./assets/images/right1.avif";

import hero1 from "./assets/images/hero1.webp";
import hero2 from "./assets/images/hero2.webp";
import hero3 from "./assets/images/hero3.webp";
import hero4 from "./assets/images/hero4.webp";
import hero5 from "./assets/images/hero5.webp";
import hero6 from "./assets/images/hero6.webp";
import hero7 from "./assets/images/hero7.webp";
import hero8 from "./assets/images/hero8.webp";
import hero9 from "./assets/images/hero9.avif";
import hero10 from "./assets/images/hero10.avif";
import hero11 from "./assets/images/hero11.avif";

import logo from "./assets/images/logo.png";
import discount from "./assets/images/discount.webp";

import icon1 from "./assets/images/icon1.png";
import icon2 from "./assets/images/icon2.png";
import icon3 from "./assets/images/icon3.png";

import video1 from "./assets/videos/video1.mp4";
import video2 from "./assets/videos/video2.mp4";
import video3 from "./assets/videos/video3.mp4";
import video4 from "./assets/videos/video4.mp4";
import video5 from "./assets/videos/video5.mp4";
import video6 from "./assets/videos/video6.mp4";
import video7 from "./assets/videos/video7.mp4";
import video8 from "./assets/videos/video8.mp4";

export const icons = {
  home: <GoHome />,

  map: <FiMapPin />,
  menu: <IoMdMenu />,
  play: <IoMdPlay />,
  pause: <FaPause />,
  downarrow: <IoIosArrowDown />,
  search: <FiSearch />,
  cross: <RxCross1 />,
  heart: <FaRegHeart />,
  user: <FaRegUser />,
  cart: <IoCartOutline />,

  // new menu-specific icons for level 0
  language: <MdLanguage />,
  walmart: <MdAddShoppingCart />,
  history: <MdHistory />,
  help: <MdHelp />,
  lists: <MdListAlt />,
  departments: <MdApps />,
  services: <MdBuild />,
  feedback: <MdFeedback />,
};

export const images = {
  sparkicon,
  mobileicon,
  fallbackimg,
  fallbackimg1,

  logo,
  discount,
  grid1,
  grid2,
  grid3,
  grid4,
  grid5,

  left1,
  right1,

  hero1,
  hero2,
  hero3,
  hero4,
  hero5,
  hero6,
  hero7,
  hero8,
  hero9,
  hero10,
  hero11,

  icon1,
  icon2,
  icon3,
};

export const products = [
  {
    longTitle: "SIXHOME Outdoor Rug 5'x8' Waterproof Reversible Patio Rug",
    deal: true,
    img: "https://i5.walmartimages.com/seo/SIXHOME-Outdoor-Rug-5-x8-Waterproof-Patio-Rug-Reversible-Indoor-Outdoor-Rug-Lightweight-Plastic-Straw-Rug-RV-Camping-Deck-Balcony-Boho-Porch-Decor-Da_19e3c14c-af4f-47df-96c3-27947063b49f.598b97958068749a3fc4526917015a83.jpeg?odnHeight=175&odnWidth=175&odnBg=FFFFFF",
    price: "$49.99",
    discountPrice: "$39.99",
    rangeMessage: "Options from $39.99 - $59.99",
    buttonText: "options",
  },
  {
    longTitle: "Restored Apple iPhone 15 128GB Unlocked - Black",
    deal: true,
    img: "https://i5.walmartimages.com/seo/Restored-Apple-iPhone-15-128GB-Unlocked-Black-MTLV3LL-A-Excellent-Condition_733b3ac5-03e5-4c6e-81c3-f00cffc8f0a6.dc58f267dd1de727dc23e35a3685e738.jpeg?odnHeight=175&odnWidth=175&odnBg=FFFFFF",
    price: "$699",
    discountPrice: "$649",
    rangeMessage: "Options from $649 - $799",
    buttonText: "options",
  },
  {
    longTitle: "Wonder Nation Boys' Everyday Swim Rash Guard - UPF50",
    deal: true,
    img: "https://i5.walmartimages.com/seo/Wonder-Nation-Boys-Everyday-Swim-Rash-Guard-with-UPF50-Sizes-4-18-Husky_7dd9610f-974f-4225-9f6d-50c797712225.1d91be83b0f025f22399d10edd015358.jpeg?odnHeight=175&odnWidth=175&odnBg=FFFFFF",
    price: "$14.96",
    discountPrice: "$14.96",
    rangeMessage: "",
    buttonText: "add",
  },
  {
    longTitle: '87" Corduroy 3-Seater Sofa with Deep Seats - Green',
    deal: true,
    img: "https://i5.walmartimages.com/seo/87-Corduroy-Sofa-3-Seater-Sofa-with-Extra-Deep-Seats-Neche-Comfy-Upholstered-Couch-for-Living-Room-2-Pillows-Green_15a5f04b-e374-4505-91e5-fe403e4db106.0bc81d68599ca9c2df51ff7ec978e0ef.jpeg?odnHeight=175&odnWidth=175&odnBg=FFFFFF",
    price: "$499",
    discountPrice: "$429",
    rangeMessage: "Options from $429 - $599",
    buttonText: "options",
  },
  {
    longTitle: "KingCamp Cotton Flannel Wearable Sleeping Bag - Green",
    deal: true,
    img: "https://i5.walmartimages.com/seo/KingCamp-Cotton-Flannel-Sleeping-Bag-Oversized-Wearable-for-Camping-Hiking-Travel-9-F-44-F-Green_40bbd074-4551-49f6-9f98-408dffa97c1e.1bbad02832dd9f220df8d49b2b97a6a3.jpeg?odnHeight=175&odnWidth=175&odnBg=FFFFFF",
    price: "$59.99",
    discountPrice: "$59.99",
    rangeMessage: "",
    buttonText: "add",
  },
  {
    longTitle: "JUSTLET Luxury Down-Alternative Comforter - Queen, Gray",
    deal: true,
    img: "https://i5.walmartimages.com/seo/JUSTLET-Luxury-Solid-Down-Alternative-Machine-Washable-Gray-Comforters-Queen_22669d6e-f78d-4e41-ad30-b1d038c83fa9.b920eac05151bb01b1c135aff96eaff0.jpeg?odnHeight=175&odnWidth=175&odnBg=FFFFFF",
    price: "$89",
    discountPrice: "$65",
    rangeMessage: "Options from $65 - $109",
    buttonText: "options",
  },
  {
    longTitle: "SIXHOME Outdoor Rug 5'x8' Waterproof Reversible Patio Rug",
    deal: true,
    img: "https://i5.walmartimages.com/seo/SIXHOME-Outdoor-Rug-5-x8-Waterproof-Patio-Rug-Reversible-Indoor-Outdoor-Rug-Lightweight-Plastic-Straw-Rug-RV-Camping-Deck-Balcony-Boho-Porch-Decor-Da_19e3c14c-af4f-47df-96c3-27947063b49f.598b97958068749a3fc4526917015a83.jpeg?odnHeight=175&odnWidth=175&odnBg=FFFFFF",
    price: "$49.99",
    discountPrice: "$49.99",
    rangeMessage: "",
    buttonText: "add",
  },
  {
    longTitle: "Restored Apple iPhone 15 128GB Unlocked - Black",
    deal: true,
    img: "https://i5.walmartimages.com/seo/Restored-Apple-iPhone-15-128GB-Unlocked-Black-MTLV3LL-A-Excellent-Condition_733b3ac5-03e5-4c6e-81c3-f00cffc8f0a6.dc58f267dd1de727dc23e35a3685e738.jpeg?odnHeight=175&odnWidth=175&odnBg=FFFFFF",
    price: "$699",
    discountPrice: "$699",
    rangeMessage: "",
    buttonText: "add",
  },
  {
    longTitle: "Wonder Nation Boys' Everyday Swim Rash Guard - UPF50",
    deal: true,
    img: "https://i5.walmartimages.com/seo/Wonder-Nation-Boys-Everyday-Swim-Rash-Guard-with-UPF50-Sizes-4-18-Husky_7dd9610f-974f-4225-9f6d-50c797712225.1d91be83b0f025f22399d10edd015358.jpeg?odnHeight=175&odnWidth=175&odnBg=FFFFFF",
    price: "$14.96",
    discountPrice: "$11.96",
    rangeMessage: "",
    buttonText: "add",
  },
  {
    longTitle: '87" Corduroy 3-Seater Sofa with Deep Seats - Green',
    deal: true,
    img: "https://i5.walmartimages.com/seo/87-Corduroy-Sofa-3-Seater-Sofa-with-Extra-Deep-Seats-Neche-Comfy-Upholstered-Couch-for-Living-Room-2-Pillows-Green_15a5f04b-e374-4505-91e5-fe403e4db106.0bc81d68599ca9c2df51ff7ec978e0ef.jpeg?odnHeight=175&odnWidth=175&odnBg=FFFFFF",
    price: "$499",
    discountPrice: "$499",
    rangeMessage: "",
    buttonText: "add",
  },
  {
    longTitle: "KingCamp Cotton Flannel Wearable Sleeping Bag - Green",
    deal: true,
    img: "https://i5.walmartimages.com/seo/KingCamp-Cotton-Flannel-Sleeping-Bag-Oversized-Wearable-for-Camping-Hiking-Travel-9-F-44-F-Green_40bbd074-4551-49f6-9f98-408dffa97c1e.1bbad02832dd9f220df8d49b2b97a6a3.jpeg?odnHeight=175&odnWidth=175&odnBg=FFFFFF",
    price: "$59.99",
    discountPrice: "$49.99",
    rangeMessage: "Options from $49.99 - $69.99",
    buttonText: "options",
  },
  {
    longTitle: "JUSTLET Luxury Down-Alternative Comforter - Queen, Gray",
    deal: true,
    img: "https://i5.walmartimages.com/seo/JUSTLET-Luxury-Solid-Down-Alternative-Machine-Washable-Gray-Comforters-Queen_22669d6e-f78d-4e41-ad30-b1d038c83fa9.b920eac05151bb01b1c135aff96eaff0.jpeg?odnHeight=175&odnWidth=175&odnBg=FFFFFF",
    price: "$89",
    discountPrice: "$89",
    rangeMessage: "",
    buttonText: "add",
  },
  {
    longTitle: "Outdoor Rug 5'x8' Waterproof Patio Mat - Reversible Design",
    deal: true,
    img: "https://i5.walmartimages.com/seo/SIXHOME-Outdoor-Rug-5-x8-Waterproof-Patio-Rug-Reversible-Indoor-Outdoor-Rug-Lightweight-Plastic-Straw-Rug-RV-Camping-Deck-Balcony-Boho-Porch-Decor-Da_19e3c14c-af4f-47df-96c3-27947063b49f.598b97958068749a3fc4526917015a83.jpeg?odnHeight=175&odnWidth=175&odnBg=FFFFFF",
    price: "$52.99",
    discountPrice: "$45.99",
    rangeMessage: "Options from $45.99 - $64.99",
    buttonText: "options",
  },
  {
    longTitle: "Luxury Gray Down-Alternative Comforter - Full/Queen",
    deal: true,
    img: "https://i5.walmartimages.com/seo/JUSTLET-Luxury-Solid-Down-Alternative-Machine-Washable-Gray-Comforters-Queen_22669d6e-f78d-4e41-ad30-b1d038c83fa9.b920eac05151bb01b1c135aff96eaff0.jpeg?odnHeight=175&odnWidth=175&odnBg=FFFFFF",
    price: "$75.00",
    discountPrice: "$75.00",
    rangeMessage: "",
    buttonText: "add",
  },
  {
    longTitle: "KingCamp Flannel Sleeping Bag for Cold Weather Camping",
    deal: true,
    img: "https://i5.walmartimages.com/seo/KingCamp-Cotton-Flannel-Sleeping-Bag-Oversized-Wearable-for-Camping-Hiking-Travel-9-F-44-F-Green_40bbd074-4551-49f6-9f98-408dffa97c1e.1bbad02832dd9f220df8d49b2b97a6a3.jpeg?odnHeight=175&odnWidth=175&odnBg=FFFFFF",
    price: "$69.00",
    discountPrice: "$58.00",
    rangeMessage: "Options from $58.00 - $74.00",
    buttonText: "options",
  },
];

export const categories = [
  {
    title: "Grocery",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-d59a/k2-_3c62c186-8ec0-4541-9e7c-24efaa163e9f.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Electronics",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-6665/k2-_ddcfae2e-c70f-43f6-b234-71fcba59bdac.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Clothing",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-68c6/k2-_c36c35d7-7a6f-4108-86ec-4451a17ec151.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Home",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-e6a0/k2-_c07e4bfc-6a34-4d51-9167-c6f84f45aa95.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Baby",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-bc3f/k2-_f9f33c27-2e99-476e-95f5-a3beabd12f54.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Toys",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-3d34/k2-_e39033d8-6523-4ee6-9cc3-67c2baf667d5.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Health & Beauty",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-bc93/k2-_5c8044b6-cd62-4615-86fa-8b20acb71786.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Pharmacy",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-33d9/k2-_d07759dd-36d5-4f1e-822b-de3b43b3583f.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Pets",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-1222/k2-_8202a2b0-4157-4602-a0c9-9bcee5a5f589.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Auto & Tires",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-f4d9/k2-_f947ef1f-52fe-461a-9e0a-0c91b35ca076.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Sports & Outdoors",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-44dd/k2-_a505e49e-9b6b-4b4d-b8fc-e8c6506a9fa8.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Office Supplies",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-d59a/k2-_3c62c186-8ec0-4541-9e7c-24efaa163e9f.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Books",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-6665/k2-_ddcfae2e-c70f-43f6-b234-71fcba59bdac.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Furniture",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-68c6/k2-_c36c35d7-7a6f-4108-86ec-4451a17ec151.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Appliances",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-e6a0/k2-_c07e4bfc-6a34-4d51-9167-c6f84f45aa95.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Crafts",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-bc3f/k2-_f9f33c27-2e99-476e-95f5-a3beabd12f54.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Party Supplies",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-3d34/k2-_e39033d8-6523-4ee6-9cc3-67c2baf667d5.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Music & Movies",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-bc93/k2-_5c8044b6-cd62-4615-86fa-8b20acb71786.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Gift Cards",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-33d9/k2-_d07759dd-36d5-4f1e-822b-de3b43b3583f.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Video Games",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-1222/k2-_8202a2b0-4157-4602-a0c9-9bcee5a5f589.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Walmart Services",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-f4d9/k2-_f947ef1f-52fe-461a-9e0a-0c91b35ca076.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "School & College",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-44dd/k2-_a505e49e-9b6b-4b4d-b8fc-e8c6506a9fa8.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
  {
    title: "Savings & Deals",
    image:
      "https://i5.walmartimages.com/dfw/4ff9c6c9-d59a/k2-_3c62c186-8ec0-4541-9e7c-24efaa163e9f.v1.png?odnHeight=120&odnWidth=120&odnBg=FFFFFF",
  },
];

const videos = {
  video1,
  video2,
  video3,
  video4,
  video5,
  video6,
  video7,
  video8,
};

export const videoProducts = [
  {
    video: videos.video1,
    img: products[0].img,
    price: products[0].price,
    longTitle: products[0].longTitle,
  },
  {
    video: videos.video2,
    img: products[1].img,
    price: products[1].price,
    longTitle: products[1].longTitle,
  },
  {
    video: videos.video3,
    img: products[2].img,
    price: products[2].price,
    longTitle: products[2].longTitle,
  },
  {
    video: videos.video4,
    img: products[3].img,
    price: products[3].price,
    longTitle: products[3].longTitle,
  },
  {
    video: videos.video5,
    img: products[4].img,
    price: products[4].price,
    longTitle: products[4].longTitle,
  },
  {
    video: videos.video6,
    img: products[5].img,
    price: products[5].price,
    longTitle: products[5].longTitle,
  },
  {
    video: videos.video7,
    img: products[6].img,
    price: products[6].price,
    longTitle: products[6].longTitle,
  },
  {
    video: videos.video8,
    img: products[7].img,
    price: products[7].price,
    longTitle: products[7].longTitle,
  },
];
